(function () {
  'use strict';
  // A basket can fit the selected Pesado portafilter without fitting the OEM one.
  // Keep that condition consistent in the guide, PDP and cart; never block owners
  // who already have a compatible Pesado portafilter from buying a basket alone.
  function isGemilai(context) {
    if (!context) return false;
    var brand = context.brandRecord || context.brand || context;
    var id = context.brandId || brand.id || brand.slug || brand.name || brand;
    return String(id).trim().toLowerCase() === 'gemilai';
  }
  function legacyRequirement(context, product) {
    if (!product) return null;
    var meta = product.meta || product.item || product;
    var handle = meta.handle || '';
    var id = meta.recommendationId || meta.id || '';
    var model = context && (context.model || {});
    var modelId = context && (context.modelId || model.id);
    if (modelId === 'rocket--r9-r-nine-one' &&
        (id === 'basket_58' || handle === 'high-extraction-filter-basket')) {
      return {
        title: 'HE basket compatibility by size',
        short: 'Original portafilter: Small / Medium only.',
        message: 'Small and Medium HE baskets fit the original Rocket R9 portafilter. Large and X-Large are not confirmed compatible and are not offered for this model.',
        compact: 'S/M: original PF only.',
        fitLabel: 'Original: S / M only',
        bannerPrefix: 'Check HE basket size · '
      };
    }
    if (modelId === 'rocket--domestic-all-e61-models' &&
        (id === 'basket_58' || handle === 'high-extraction-filter-basket')) {
      return {
        title: 'HE basket compatibility by size',
        short: 'Original portafilter: Small / Medium only. Large / X-Large require Pesado.',
        message: 'Small and Medium HE baskets fit the original Rocket Domestic E61 portafilter. Large and X-Large require a compatible Pesado 58 mm portafilter; compatibility with the original portafilter is not guaranteed.',
        compact: 'S/M: original PF.<br>L/XL: Pesado PF only.',
        fitLabel: 'Original: S / M only',
        bannerPrefix: 'Check HE basket size · '
      };
    }
    if (['profitec--e61-models', 'profitec--pro-300', 'profitec--pro-400', 'profitec--leva-pro-series'].indexOf(modelId) !== -1 &&
        (id === 'basket_58' || handle === 'high-extraction-filter-basket')) {
      var profitecName = {'profitec--e61-models': 'E61 models', 'profitec--pro-300': 'Pro 300', 'profitec--pro-400': 'Pro 400', 'profitec--leva-pro-series': 'Pro 800 Leva'}[modelId];
      var originalOnly = modelId === 'profitec--leva-pro-series';
      return {
        title: 'HE basket compatibility by size',
        short: originalOnly ? 'Original portafilter: Small / Medium only.' : 'Original portafilter: Small / Medium only. Large / X-Large require Pesado.',
        message: 'Small and Medium HE baskets fit the original Profitec ' + profitecName + ' portafilter. ' + (originalOnly ? 'Large and X-Large are not confirmed compatible and are not offered for this model.' : 'Large and X-Large require a compatible Pesado 58 mm portafilter; compatibility with the original portafilter is not guaranteed.'),
        compact: originalOnly ? 'S/M: original PF only.' : 'S/M: original PF.<br>L/XL: Pesado PF only.',
        fitLabel: 'Original: S / M only',
        bannerPrefix: 'Check HE basket size · '
      };
    }
    if (['orchestrale--etnica', 'orchestrale--nota', 'orchestrale--phonica', 'orchestrale--radiofonica'].indexOf(modelId) !== -1 &&
        (id === 'basket_58' || handle === 'high-extraction-filter-basket')) {
      var orchestraleModel = {
        'orchestrale--etnica': 'Etnica',
        'orchestrale--nota': 'NOTA',
        'orchestrale--phonica': 'Phonica',
        'orchestrale--radiofonica': 'Radiofonica'
      }[modelId];
      return {
        title: 'HE basket compatibility by size',
        short: 'Original portafilter: Small / Medium only. Large / X-Large require Pesado.',
        message: 'Small and Medium HE baskets fit the original Orchestrale ' + orchestraleModel + ' portafilter. Large and X-Large require a compatible Pesado 58 mm portafilter; compatibility with the original portafilter is not guaranteed.',
        compact: 'S/M: original PF.<br>L/XL: Pesado PF only.',
        fitLabel: 'Original: S / M only',
        bannerPrefix: 'Check HE basket size · '
      };
    }
    if (modelId === 'la-pavoni--e61-models' &&
        (id === 'basket_58' || handle === 'high-extraction-filter-basket')) {
      return {
        title: 'HE basket compatibility by size',
        short: 'Original portafilter: Small / Medium only. Large / X-Large require Pesado.',
        message: 'Small and Medium HE baskets fit the original La Pavoni E61 portafilter. Large and X-Large require a compatible Pesado 58 mm portafilter; compatibility with the original portafilter is not guaranteed.',
        compact: 'S/M: original PF.<br>L/XL: Pesado PF only.',
        fitLabel: 'Original: S / M only',
        bannerPrefix: 'Check HE basket size · '
      };
    }
    if ((modelId === 'expobar--commercial' || modelId === 'expobar--office' || modelId === 'crem--commercial') &&
        (id === 'basket_58' || handle === 'high-extraction-filter-basket')) {
      var machine = modelId === 'crem--commercial' ? 'CREM Commercial' :
        (modelId === 'expobar--office' ? 'Expobar Office' : 'Expobar Commercial');
      return {
        title: 'HE basket compatibility',
        short: 'Fits Pesado 58 mm portafilters. Original portafilter fit is not guaranteed.',
        message: 'Compatible with Pesado 58 mm portafilters. Compatibility with the original ' +
          machine + ' portafilter is not guaranteed.'
      };
    }
    if ((modelId === 'elektra--kup' || modelId === 'elektra--verve') &&
        (id === 'basket_58' || handle === 'high-extraction-filter-basket')) {
      return {
        title: 'HE basket compatibility',
        short: 'Fits Pesado 58 mm portafilters. Original portafilter fit is not guaranteed.',
        message: 'Compatible with Pesado 58 mm portafilters. Compatibility with the original Elektra ' +
          (modelId === 'elektra--kup' ? 'KUP' : 'Verve') + ' portafilter is not guaranteed.'
      };
    }
    if (modelId === 'brasilia--mini-mighty' &&
        (id === 'basket_58' || handle === 'high-extraction-filter-basket')) {
      return {
        title: 'HE basket compatibility',
        short: 'Fits Pesado 58 mm portafilters. Original portafilter fit is not guaranteed.',
        message: 'Compatible with Pesado 58 mm portafilters. Compatibility with the original Brasilia Mini Mighty portafilter is not guaranteed.'
      };
    }
    if (!isGemilai(context)) return null;
    if (!['ep_58', 'basket_58'].includes(id) &&
        !['pesado-ep-filter-basket', 'high-extraction-filter-basket'].includes(handle)) return null;
    return {
      title: 'Pesado portafilter required',
      short: 'Requires a compatible Pesado portafilter.',
      message: 'EP and HE baskets do not fit the original Gemilai portafilter. Use with a compatible Pesado portafilter.'
    };
  }
  // The Manager notice is authoritative. Model-ID fallback also covers cart
  // contexts that do not carry the full model record.
  var breville58Names = {
    'breville--dual-boiler': 'Breville Dual Boiler',
    'breville--dynamic-duo': 'Breville Dynamic Duo',
    'breville--oracle-oracle-touch': 'Breville Oracle / Oracle Touch',
    'breville--oracle-dual-boiler': 'Breville Oracle Dual Boiler',
    'breville--the-oracle-jet': 'Breville The Oracle Jet',
    'breville--dual-boiler-2026': 'Breville Dual Boiler 2026',
    'sage--58mm': 'Sage 58mm',
    'solis--58mm': 'Solis 58mm'
  };
  function requirement(context, product) {
    if (!product) return null;
    var meta = product.meta || product.item || product;
    var id = meta.recommendationId || meta.id || '';
    var model = context && (context.model || context) || {};
    var modelId = context && (context.modelId || model.id);
    var name = breville58Names[modelId];
    if (name && (id === 'basket_58' || meta.handle === 'high-extraction-filter-basket')) {
      return {
        title: 'HE basket compatibility by size',
        short: 'Original portafilter: Small only. Other sizes require Pesado.',
        message: model.heBasketFitNotice || 'Only the Small HE basket fits the original ' + name + ' portafilter. Medium, Large and X-Large require a compatible Pesado Breville 58 mm portafilter; compatibility with the original portafilter is not guaranteed.',
        fitLabel: 'Original: Small only',
        bannerPrefix: 'Check HE basket size · '
      };
    }
    return legacyRequirement(context, product);
  }
  function markup(context, product) {
    var notice = requirement(context, product);
    function escape(value) { return String(value).replace(/[&<>"']/g, function (c) { return {'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c]; }); }
    return notice ? '<aside class="pesado-fit-requirement' + (notice.compact ? ' pesado-fit-requirement--compact' : '') + '"><strong>' + escape(notice.title) + '</strong><span>' + escape(notice.message) + '</span>' + (notice.compact ? '<span class="pesado-fit-requirement__compact">' + notice.compact + '</span>' : '') + '</aside>' : '';
  }
  window.PesadoFitRequirements = { isGemilai: isGemilai, get: requirement, markup: markup };
})();
